import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaterialsService {

  constructor(
    private http: HttpClient
  ) { }

  getMaterials() {
    return (this.http.get(`${environment.apiUrl}/materials`));
  }

  createMaterial(data: any) {
    return (this.http.post(`${environment.apiUrl}/materials`, data));
  }

  updateMaterial(data: any) {
    return (this.http.put(`${environment.apiUrl}/materials/${data.fert}`, data));
  }

  deleteMaterial(id: number) {
    return (this.http.delete(`${environment.apiUrl}/materials/${id}`));
  }
}
